import axios from 'axios';

const luceniaServer = 
  process.env.REACT_APP_LUCENIA_SERVER ||
  'https://santa.lucenia.dev/santa-app-server/api';

  console.log('Lucenia Server:', luceniaServer);

export const fetchCountries = async () => {
  try {
    const response = await axios.get(`${luceniaServer}/countries`);
    const countryList = response.data;
    console.log('Server Response:', response); // Logs the entire response object
    console.log('Country List:', response.data); // Logs just the data property
    return ['World', ...countryList]; // Add "World" as default
  } catch (error) {
    console.error('Error fetching countries:', error);
  }
};

export const query = async (query) => {
  try {
    const response = await axios.post(`${luceniaServer}/query`, {
      query,
    });
    return response;
  } catch (error) {
    console.error('Error querying:', error);
  }
};

export const nameSearch = async (name, country) => {
  try {
    const response = await axios.post(`${luceniaServer}/nameSearch`, {
      name,
      country,
    });
    return response;
  } catch (error) {
    console.error('Error searching for name:', error);
  }
};

export const geocodeCity = async (city) => {
  try {
    const response = await axios.post(`${luceniaServer}/geocodeCity`, {
      city,
    });
    return response.data;
  } catch (error) {
    console.error('Error geocoding city:', error);
  }
};

export const handleFollowUp = async (responseName) => {
  try {
    const response = await axios.post(`${luceniaServer}/followUp`, {
      responseName,
    });
    return response;
  } catch (error) {
    console.error('Error handling follow-up question:', error);
  }
};

export const chat = async (messages) => {
  try {
    const response = await axios.post(`${luceniaServer}/chat`, {
      messages,
    });
    return response;
  } catch (error) {
    console.error('Error during chat:', error);
  }
};

export const chatWithLuceniaData = async (messages, luceniaData) => {
  try {
    const response = await axios.post(`${luceniaServer}/chatWithLuceniaData`, {
      messages,
      luceniaData
    });
    return response;
  } catch (error) {
    console.error('Error during chat with Lucenia data:', error);
  }
}

export const locations = async () => {
  try {
    const response = await axios.get(`${luceniaServer}/locations`);
    return response;
  } catch (error) {
    console.error('Error fetching locations:', error);
  }
};

export const stats = async () => {
  try {
    const response = await axios.get(`${luceniaServer}/stats`);
    return response.data;
  } catch (error) {
    console.error('Error fetching stats:', error);
  }
};

/** fetches nice cities near the provided coordinates */
export const fetchNiceCitiesNear = async (coordinates) => {
  try {
    const queryPayload = {
      size: 5,
      query: {
          function_score: {
              query: {
                  geo_distance: {
                      distance: "100km",
                      Coordinates: {
                          lat: coordinates.lat,
                          lon: coordinates.lon
                      }
                  }
              },
              field_value_factor: {
                  field: "nice_score",
                  factor: 1,
                  modifier: "log1p",
                  missing: 0
              }
          }
      },
      sort: [{ _score: "desc" }]
    };
    console.log("Sending query to Lucenia:", JSON.stringify(queryPayload, null, 2));

    const response = await axios.post(`${luceniaServer}/generalLuceniaQuery`, {
      index: 'cities',
      query: queryPayload,
    });

    return response;
  } catch (error) {
    console.error('Error fetching nice cities near:', error);
  }
}
